@use "~theme/breakpoints";

.prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--blue-03);
  border-radius: 4px;
  padding: 16px 0;

  @include breakpoints.desktop {
    flex-direction: row;
    justify-content: center;
    padding: 12px 0;
  }
}

.promptHeadline {
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  > img {
    margin-right: 0.5em;
  }

  @include breakpoints.desktop {
    margin-right: 0.5em;
    margin-bottom: 0;
  }
}

.somethingWentWrong {
  color: var(--red);
}

.modal {
  max-width: 607px;
  max-height: calc(100vh - 50px);
  height: calc(100vh - 50px);
}

.modalOverlay {
  align-items: initial;
}
